module.exports = __webpack_public_path__ + "img/photo-02.6a616059.png";